const JOB_STATUS = {
  IN_PROGRESS: 'IN-PROGRESS',
  DONE: 'COMPLETE',
  NOT_STARTED: 'NOT_STARTED',
} as const;

export default JOB_STATUS;

export const TAB_VALUES = {
  ALL: 'all',
  EXTERNAL: 'external',
} as const;
